import z from "zod";

import { InsuredContactShape } from "./insured_contact";

export const CglContactSchema = z.object({
	...InsuredContactShape,
	nameOfInsured: z.string().describe("The name of the insured"),
	address: z.object({
		city: z.string(),
		state: z.string().describe("State of the insured. Should be 2 letters, like TX for Texas"),
		streetAddress: z.string(),
		zip: z.string(),
	}).describe("Address of the insured"),
	brokerage: z.string().describe("the name of the brokerage submitting the submission"),
	brokerName: z.string().describe("the name of the broker submitting the submission").nullable().default(null),
	brokerEmail: z.string().describe("the email of the broker submitting the submission. Sometimes submissions are forwarded from classa.ai emails. classa.ai emails are never the broker.").nullable().default(null),
});

export const CglTermsSchema = z.object({
	inceptionDate: z.iso.date().describe("the date in which the policy would start. For an existing policy, this would be the existing expiration date.").nullable().default(null),
	operationsDescription: z.string().describe("A brief 1-3 sentence description of the insured's aviation-related operations").nullable().default(null),
	premisesLocations: z.array(z.string()).describe("The airport or premises locations to be covered, one string per location").default([]),
});

export const CglCoverageSchema = z.object({
	generalAggregateLimit: z.number().describe("The requested general aggregate limit, other than products / completed operations").nullable().default(null),
	eachOccurrenceLimit: z.number().describe("The requested each occurrence limit").nullable().default(null),
	productsCompletedOpsAggregateLimit: z.number().describe("The requested products / completed operations aggregate limit").nullable().default(null),
	hangarkeepersEachLossLimit: z.number().describe("The requested hangarkeeper's liability limit for each loss. A hangarkeeper's limit written per occurrence is the each loss limit.").nullable().default(null),
	hangarkeepersEachAircraftLimit: z.number().describe("The requested hangarkeeper's liability limit for each aircraft").nullable().default(null),
});

export const CglExposureSchema = z.object({
	fuelSales: z.number().describe("Annual gross receipts from sales of fuel and oil in US dollars, excluding pumping fees. Add the grades together when the submission breaks them out by 100LL, Jet A, or airline fuel.").nullable().default(null),
	fuelGallons: z.number().describe("Annual gallons of fuel sold. Add the grades together when the submission breaks them out by grade.").nullable().default(null),
});

export const CGLSubmissionSchema = z.object({
	...CglContactSchema.shape,
	...CglTermsSchema.shape,
	...CglCoverageSchema.shape,
	exposure: CglExposureSchema,
	lob: z.literal("commercial_general_liability"),
});

export type CGLSubmission = z.output<typeof CGLSubmissionSchema>;
